import { useNavigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { formatINR, formatDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/TxnBadges";

const HEAD = "label-overline text-slate-500";

const MessageRow = ({ children }) => (
  <TableRow>
    <TableCell colSpan={6} className="text-center py-12 text-slate-500">{children}</TableCell>
  </TableRow>
);

const CustomerRow = ({ c }) => {
  const navigate = useNavigate();
  return (
    <TableRow data-testid={`customer-row-${c.id}`}>
      <TableCell className="font-medium text-slate-900">{c.name}</TableCell>
      <TableCell className="font-mono-num text-slate-700">{c.mobile}</TableCell>
      <TableCell><StatusBadge status={c.status} /></TableCell>
      <TableCell className="text-sm text-slate-500">{formatDate(c.created_at)}</TableCell>
      <TableCell className="font-mono-num text-right text-slate-900">{formatINR(c.balance)}</TableCell>
      <TableCell className="text-right">
        <Button variant="outline" size="sm" data-testid={`open-customer-${c.id}`}
          onClick={() => navigate(`/admin/customers/${c.id}`)} className="gap-1">
          Manage <ExternalLink className="h-3 w-3" />
        </Button>
      </TableCell>
    </TableRow>
  );
};

function Rows({ customers, loading }) {
  if (loading) return <MessageRow>Loading customers…</MessageRow>;
  if (customers.length === 0)
    return <MessageRow>No customers yet. Click "Add customer" to create the first one.</MessageRow>;
  return customers.map((c) => <CustomerRow key={c.id} c={c} />);
}

export const CustomersTable = ({ customers, loading }) => (
  <Table data-testid="customers-table">
    <TableHeader>
      <TableRow className="bg-slate-50 hover:bg-slate-50">
        <TableHead className={HEAD}>Name</TableHead>
        <TableHead className={HEAD}>Mobile</TableHead>
        <TableHead className={HEAD}>Status</TableHead>
        <TableHead className={HEAD}>Created</TableHead>
        <TableHead className={`${HEAD} text-right`}>Balance</TableHead>
        <TableHead className={`${HEAD} text-right`}>Actions</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      <Rows customers={customers} loading={loading} />
    </TableBody>
  </Table>
);
